import { ReactComponent as PolicyIconSVG } from "./p-policy.svg";
import { SvgIcon } from '@mui/material';

export default function IconPPolicy(props) {
  return <SvgIcon {...props} component={PolicyIconSVG} viewBox="0 0 14 18" />;
}